(ns common.schema.entities.sample-entity.options)

(def sample-status-options
  [{:key :sample.status/active :label "Active"}
   {:key :sample.status/inactive :label "Inactive"}
   {:key :sample.status/pending :label "Pending"}
   {:key :sample.status/archived :label "Archived"}])

(def sample-tags-options
  [{:key :sample.tag/alpha :label "Alpha"}
   {:key :sample.tag/beta :label "Beta"}
   {:key :sample.tag/gamma :label "Gamma"}
   {:key :sample.tag/delta :label "Delta"}
   {:key :sample.tag/epsilon :label "Epsilon"}
   {:key :sample.tag/zeta :label "Zeta"}])
